// extracted by mini-css-extract-plugin
module.exports = {"Page":"styles_Page__mxxH_","cloudPage":"styles_cloudPage__weDJr","darkMode":"styles_darkMode__IdJ_i","main":"styles_main__H0PiI","bannerSticky":"styles_bannerSticky__mxbJl"};